<template>
  <div class="number-input">
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'" :for="options.name">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <input class="form-control" type="text"
          :class="formControlValidationClass"
          :value="value"
          @input="validate($event.target.value)"
          :name="options.name"/>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    validationClass,
    formControlValidationClass,
    validationMessage
  } from '@/util/helpers'

  export default {
    name: 'NumberInput',
    props: {
      value: {
        type: [Number, String]
      },
      options: {
        type: Object,
        default () {
          return {
            value: ''
          }
        }
      }
    },
    data () {
      return {
        isDirty: false,
        isValid: false,
        isLength: false,
        isRegex: false,
        regex: /^[0-9]+$/,
        maxVal: false
      }
    },
    computed: {
      validationClass,
      formControlValidationClass,
      validationMessage,
      invalidMessage () {
        if (this.maxVal && this.maxVal !== 0 && Math.ceil(this.value) > this.maxVal) {
          return 'You may only enter a number up to ' + this.maxVal
        } else if (!this.options.required) {
          return 'The number entered is not valid'
        } else {
          return this.options.label + ' is required'
        }
      }
    },
    mounted () {
      if (this.options.maxVal) this.maxVal = this.options.maxVal
      this.validate(this.value)
    },
    methods: {
      validate (val = this.value) {
        val = val === undefined ? '' : val
        this.$emit('input', val)
        if (this.options.required) {
          this.isDirty = true
          this.isValid = !Number.isNaN(Math.floor(val)) && val !== '' && !val.toString().includes('.')
          if (this.maxVal && this.maxVal !== 0) {
            this.isValid = this.isValid && Math.ceil(val) <= this.maxVal
          }
          this.isLength = val.length >= this.minLength
        } else {
          this.isDirty = val && val !== ''
          this.isValid = !Number.isNaN(Math.floor(val)) && !val.toString().includes('.')
          if (this.maxVal && this.maxVal !== 0) {
            this.isValid = this.isValid && Math.ceil(val) <= this.maxVal
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/NumberInput.vue